import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=080e636f&scoped=true&"
import script from "./DialogContainer.vue?vue&type=script&lang=js&"
export * from "./DialogContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e636f",
  null
  
)

export default component.exports